import { memo, useLayoutEffect, useRef, useState } from "react"

import { isNil } from "@izettle/react"

import { useDropdown } from "../../hooks"

import { Badge, Button, Chevron, Text } from "./components"

export const Handler = memo(() => {
  const textRef = useRef<HTMLDivElement>(null)
  const [isSelectedBadgeVisible, setIsSelectedBadgeVisible] = useState(false)

  const {
    isOpen,
    isMultiple,
    displayText,
    placeholder = "",
    toggle,
    value,
  } = useDropdown()

  useLayoutEffect(() => {
    if (!isMultiple || isNil(textRef.current) || isNil(textRef.current.firstChild)) {
      return
    }

    const textWrapperBounds = textRef.current.getBoundingClientRect()

    const documentRange = document.createRange()
    documentRange.selectNodeContents(textRef.current.firstChild)

    const textBounds = documentRange.getClientRects()

    // If whole displayText does not fit in it's container element -
    // show number of selected options badge
    setIsSelectedBadgeVisible(textBounds[0].width > textWrapperBounds.width)
  }, [displayText, isMultiple])

  return (
    <Button isOpen={isOpen} onClick={toggle}>
      {displayText.length === 0 && <div>{placeholder}</div>}
      {displayText.length > 0 && <Text ref={textRef}>{displayText}</Text>}

      {isMultiple && isSelectedBadgeVisible && <Badge>({value.length})</Badge>}

      <Chevron isUp={isOpen} />
    </Button>
  )
})
